module.exports = __webpack_public_path__ + "img/memberYoutube.c18fbcfb.png";